import React from "react";
import { Theme, Paper } from "@material-ui/core";
import SMAButton from "../../shared/Button/Button";
import { makeStyles } from "@material-ui/core/styles";
import themeDark from "../../shared/themeDark";

const useStyles = makeStyles((theme: Theme) => ({
  root: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0",
    width: "100%",
  }),
  startButton: {},
  editDetailsButton: {
    marginTop: "15px",
  },
}));

const StartScreen = ({ onStart }: any) => {
  const classes = useStyles(themeDark);

  return (
    <Paper className={classes.root}>
      <SMAButton
        className={classes.startButton}
        color="primary"
        variant="contained"
        onAction={onStart}
      >
        Start
      </SMAButton>
    </Paper>
  );
};

export default StartScreen;
